
    import './styles.scoped.css';
    export default {
  "sticky-notifications": "awsui_sticky-notifications_154bi_ivos2_9",
  "sticky-notifications-with-background": "awsui_sticky-notifications-with-background_154bi_ivos2_13",
  "has-notifications-content": "awsui_has-notifications-content_154bi_ivos2_17"
};
  